function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.105 15c0 2.693 2.19 4.875 4.897 4.875 2.703 0 4.896-2.182 4.896-4.875 0-2.691-2.193-4.875-4.896-4.875-2.707 0-4.897 2.184-4.897 4.875zm1.632-13h6.53c0 2.693 2.191 4.875 4.896 4.875.785 0 1.531-.184 2.189-.513L27.5 10.64A4.87 4.87 0 0024.795 15a4.87 4.87 0 002.705 4.361l-2.148 4.28a4.876 4.876 0 00-2.189-.516c-2.705 0-4.897 2.184-4.897 4.875h-6.529c0-2.691-2.194-4.875-4.897-4.875-.788 0-1.532.185-2.192.515L2.5 19.361A4.873 4.873 0 005.208 15 4.872 4.872 0 002.5 10.64l2.148-4.279c.66.33 1.404.514 2.192.514 2.703 0 4.897-2.182 4.897-4.875z",
  fill: "currentColor"
})));